export default {
    "Connecticut": "isis.rodriguezarana@dxc.com",
    "North Carolina, Charlotte": "isis.rodriguezarana@dxc.com",
    "Michigan, Farmington Hills": "isis.rodriguezarana@dxc.com",
    "Washington": "isis.rodriguezarana@dxc.com",
    "Minneapolis, MN": "isis.rodriguezarana@dxc.com",
    "Georgia (U.S. state)": "isis.rodriguezarana@dxc.com",
    "Florida, Tampa": "isis.rodriguezarana@dxc.com",
    "Novi, MI": "isis.rodriguezarana@dxc.com",
    "Minnesota": "isis.rodriguezarana@dxc.com",
    "Florida, Miami": "isis.rodriguezarana@dxc.com",
    "Twinsburg, OH": "isis.rodriguezarana@dxc.com",
    "New Jersey, Weehawken": "isis.rodriguezarana@dxc.com",
    "Raleigh, NC": "isis.rodriguezarana@dxc.com",
    "Texas": "isis.rodriguezarana@dxc.com",
    "Highlands Ranch, CO": "isis.rodriguezarana@dxc.com",
    "Naperville, IL": "isis.rodriguezarana@dxc.com",
    "Southlake, TX": "isis.rodriguezarana@dxc.com",
    "Piscataway, NJ": "isis.rodriguezarana@dxc.com",
    "San Jose, CA": "isis.rodriguezarana@dxc.com",
    "Minnetonka, MN": "isis.rodriguezarana@dxc.com",
    "Iowa, Urbandale": "isis.rodriguezarana@dxc.com",
    "North Carolina, Cary": "isis.rodriguezarana@dxc.com",
    "Bridgewater, NJ": "isis.rodriguezarana@dxc.com",
    "Illinois": "isis.rodriguezarana@dxc.com",
    "Fort Worth, TX": "isis.rodriguezarana@dxc.com",
    "Horsham, PA": "isis.rodriguezarana@dxc.com",
    "Cummings, GA": "isis.rodriguezarana@dxc.com",
    "Goshen, CT": "isis.rodriguezarana@dxc.com",
    "New Jersey, Basking Ridge": "isis.rodriguezarana@dxc.com",
    "Pennsylvania, Philadelphia": "isis.rodriguezarana@dxc.com",
    "Washington, Bellevue": "isis.rodriguezarana@dxc.com",
    "United Arab Emirates": "thi.t.nguyen@dxc.com",
    "California": "isis.rodriguezarana@dxc.com",
    "Russia": "#N/A",
    "St. Petersburg, FL": "isis.rodriguezarana@dxc.com",
    "Herndon, VA": "isis.rodriguezarana@dxc.com",
    "Arizona": "isis.rodriguezarana@dxc.com",
    "Newark, NJ": "isis.rodriguezarana@dxc.com",
    "Mississippi": "isis.rodriguezarana@dxc.com",
    "Brandon, MS": "isis.rodriguezarana@dxc.com",
    "Ofallon, MO": "isis.rodriguezarana@dxc.com",
    "North Bergen, NJ": "isis.rodriguezarana@dxc.com",
    "Virginia": "isis.rodriguezarana@dxc.com",
    "Texas, Irving": "isis.rodriguezarana@dxc.com",
    "Walled Lake, MI": "isis.rodriguezarana@dxc.com",
    "Bedminster, NJ": "isis.rodriguezarana@dxc.com",
    "California, Santa Monica": "isis.rodriguezarana@dxc.com",
    "Eden Prairie, MN": "isis.rodriguezarana@dxc.com",
    "Rochelle Park, NJ": "isis.rodriguezarana@dxc.com",
    "Edgewater, NJ": "isis.rodriguezarana@dxc.com",
    "Ohio": "isis.rodriguezarana@dxc.com",
    "Texas, Frisco": "isis.rodriguezarana@dxc.com",
    "Michigan": "isis.rodriguezarana@dxc.com",
    "Carrolton, TX": "isis.rodriguezarana@dxc.com",
    "Buffalo, NY": "isis.rodriguezarana@dxc.com",
    "Sydney": "thi.t.nguyen@dxc.com",
    "Iowa": "isis.rodriguezarana@dxc.com",
    "Roseland, NJ": "isis.rodriguezarana@dxc.com",
    "Getzville, NY": "isis.rodriguezarana@dxc.com",
    "Des Moines, IA": "isis.rodriguezarana@dxc.com",
    "California, Irvine": "isis.rodriguezarana@dxc.com",
    "West Deptford, NJ": "isis.rodriguezarana@dxc.com",
    "Missouri": "isis.rodriguezarana@dxc.com",
    "Palo Alto, CA": "isis.rodriguezarana@dxc.com",
    "Long Island City, NY": "isis.rodriguezarana@dxc.com",
    "Morrisville, NC": "isis.rodriguezarana@dxc.com",
    "Alpharetta, GA": "isis.rodriguezarana@dxc.com",
    "Mahwah, NJ": "isis.rodriguezarana@dxc.com",
    "USA": "isis.rodriguezarana@dxc.com",
    "Vietnam": "thi.t.nguyen@dxc.com",
    "Germany": "michael.knowlton@dxc.com",
    "Dubna": "#N/A",
    "Canada": "isis.rodriguezarana@dxc.com",
    "Kyiv": "a.cherepovska@dxc.com",
    "United Kingdom": "iliyana.geosheva@dxc.com",
    "Dnipro": "a.cherepovska@dxc.com",
    "Moscow": "#N/A",
    "Odessa": "a.cherepovska@dxc.com",
    "Odesa": "a.cherepovska@dxc.com",
    "Omsk": "#N/A",
    "Bucharest": "cristina.cotutiu@dxc.com",
    "St.-Petersburg": "#N/A",
    "Switzerland": "iliyana.geosheva@dxc.com",
    "California, Los Angeles": "isis.rodriguezarana@dxc.com",
    "Other Swiss Locations": "iliyana.geosheva@dxc.com",
    "Frankfurt am Main": "michael.knowlton@dxc.com",
    "Krakow": "nikola.falek@dxc.com",
    "Singapore": "yvonne.chuahuifang@dxc.com",
    "Jacksonville, FL": "isis.rodriguezarana@dxc.com",
    "Van Buren Charter Township, MI": "isis.rodriguezarana@dxc.com",
    "Poland": "nikola.falek@dxc.com",
    "Wroclaw": "nikola.falek@dxc.com",
    "Cyprus": "iliyana.geosheva@dxc.com",
    "Boston, MA": "isis.rodriguezarana@dxc.com",
    "Bulgaria": "m.tsvetkovalazarova@dxc.com",
    "Warsaw": "nikola.falek@dxc.com",
    "London": "iliyana.geosheva@dxc.com",
    "WGC": "iliyana.geosheva@dxc.com",
    "Stuttgart": "michael.knowlton@dxc.com",
    "Mexico": "isis.rodriguezarana@dxc.com",
    "Mesa, AZ": "isis.rodriguezarana@dxc.com",
    "Sweden": "iliyana.geosheva@dxc.com",
    "Netherlands": "iliyana.geosheva@dxc.com",
    "France": "iliyana.geosheva@dxc.com",
    "Munich": "michael.knowlton@dxc.com",
    "Tricity": "nikola.falek@dxc.com",
    "Boeblingen": "michael.knowlton@dxc.com",
    "Luxembourg": "iliyana.geosheva@dxc.com",
    "Lodz": "nikola.falek@dxc.com",
    "Denmark": "iliyana.geosheva@dxc.com",
    "Copenhagen": "iliyana.geosheva@dxc.com",
    "Braunschweig": "michael.knowlton@dxc.com",
    "Cluj": "cristina.cotutiu@dxc.com",
    "Eindhoven": "iliyana.geosheva@dxc.com",
    "Malaysia": "atikah.aziz@dxc.com",
    "Penang": "atikah.aziz@dxc.com",
    "Romania": "cristina.cotutiu@dxc.com",
    "New Jersey, Jersey City": "isis.rodriguezarana@dxc.com",
    "Michigan, Detroit": "isis.rodriguezarana@dxc.com",
    "Menlo Park, CA": "isis.rodriguezarana@dxc.com",
    "New York, New York City": "isis.rodriguezarana@dxc.com",
    "Washington, Seattle": "isis.rodriguezarana@dxc.com",
    "Ruesselsheim": "michael.knowlton@dxc.com",
    "Zug": "iliyana.geosheva@dxc.com",
    "Nizhny Novgorod": "#N/A",
    "India": "pragnya.nagaraj@dxc.com",
    "Gurgaon": "pragnya.nagaraj@dxc.com",
    "Japan": "thi.t.nguyen@dxc.com",
    "Tokyo": "thi.t.nguyen@dxc.com",
    "Bangalore": "pragnya.nagaraj@dxc.com",
    "Kuala Lumpur": "atikah.aziz@dxc.com",
    "Berlin": "michael.knowlton@dxc.com",
    "Other UK Locations": "iliyana.geosheva@dxc.com",
    "China": "thi.t.nguyen@dxc.com",
    "Tianjin": "thi.t.nguyen@dxc.com",
    "Chennai": "pragnya.nagaraj@dxc.com",
    "Coimbatore": "pragnya.nagaraj@dxc.com",
    "Hyderabad": "pragnya.nagaraj@dxc.com",
    "Mumbai": "pragnya.nagaraj@dxc.com",
    "Shanghai": "thi.t.nguyen@dxc.com",
    "Beijing": "thi.t.nguyen@dxc.com",
    "Hong Kong": "thi.t.nguyen@dxc.com",
    "KRK BSC non-SEZ": "nikola.falek@dxc.com",
    "KRK BSC SEZ": "nikola.falek@dxc.com",
    "South Windsor, CT": "isis.rodriguezarana@dxc.com",
    "Krakow Region": "nikola.falek@dxc.com",
    "South Korea": "thi.t.nguyen@dxc.com",
    "Seoul": "thi.t.nguyen@dxc.com",
    "Philippines": "thi.t.nguyen@dxc.com",
    "Manila": "thi.t.nguyen@dxc.com",
    "Italy": "iliyana.geosheva@dxc.com",
    "Turin": "iliyana.geosheva@dxc.com",
    "Taiwan": "thi.t.nguyen@dxc.com",
    "Taipei": "thi.t.nguyen@dxc.com",
    "Australia": "thi.t.nguyen@dxc.com",
    "Melbourne": "thi.t.nguyen@dxc.com",
    "Indonesia": "thi.t.nguyen@dxc.com",
    "Jakarta": "thi.t.nguyen@dxc.com",
    "Saudi Arabia": "thi.t.nguyen@dxc.com",
    "Riyadh": "thi.t.nguyen@dxc.com",
    "Englewood, CO": "isis.rodriguezarana@dxc.com",
    "Texas, San Antonio": "isis.rodriguezarana@dxc.com",
    "DXC External Access": "isis.rodriguezarana@dxc.com",
    "Colorado, Colorado Springs": "isis.rodriguezarana@dxc.com",
    "Haymarket, VA": "isis.rodriguezarana@dxc.com",
    "New Hampshire": "isis.rodriguezarana@dxc.com",
    "Salem, NH": "isis.rodriguezarana@dxc.com",
    "Tennessee": "isis.rodriguezarana@dxc.com",
    "Tennessee, Nashville": "isis.rodriguezarana@dxc.com",
    "Glendale, CA": "isis.rodriguezarana@dxc.com",
    "Texas, Dallas": "isis.rodriguezarana@dxc.com",
    "Ingolstadt": "michael.knowlton@dxc.com",
    "Bothell, WA": "isis.rodriguezarana@dxc.com",
    "Tucson, AZ": "isis.rodriguezarana@dxc.com",
    "Millburn, NJ": "isis.rodriguezarana@dxc.com",
    "Thailand": "thi.t.nguyen@dxc.com",
    "Bangkok": "thi.t.nguyen@dxc.com",
    "Mt. Arlington, NJ": "isis.rodriguezarana@dxc.com",
    "Nevada": "isis.rodriguezarana@dxc.com",
    "Las Vegas, NV": "isis.rodriguezarana@dxc.com",
    "Livonia, Mi": "isis.rodriguezarana@dxc.com",
    "Illinois, Chicago": "isis.rodriguezarana@dxc.com",
    "Turkey": "iliyana.geosheva@dxc.com",
    "Istanbul": "iliyana.geosheva@dxc.com",
    "Deer Park, IL": "isis.rodriguezarana@dxc.com",
    "Renton, WA": "isis.rodriguezarana@dxc.com",
    "Michigan, Dearborn": "isis.rodriguezarana@dxc.com",
    "Washington, DC": "isis.rodriguezarana@dxc.com",
    "Allentown, NJ": "isis.rodriguezarana@dxc.com",
    "East Rutherford, NJ": "isis.rodriguezarana@dxc.com",
    "Phillipsburg, NJ": "isis.rodriguezarana@dxc.com",
    "Glen Rock, NJ": "isis.rodriguezarana@dxc.com",
    "Hillsdale, NJ": "isis.rodriguezarana@dxc.com",
    "Wanaque, NJ": "isis.rodriguezarana@dxc.com",
    "Oceanport, NJ": "isis.rodriguezarana@dxc.com",
    "Morristown, NJ": "isis.rodriguezarana@dxc.com",
    "Ridgefield Park, NJ": "isis.rodriguezarana@dxc.com",
    "Wyckoff, NJ": "isis.rodriguezarana@dxc.com",
    "River Edge, NJ": "isis.rodriguezarana@dxc.com",
    "Passaic, NJ": "isis.rodriguezarana@dxc.com",
    "Fair Lawn, NJ": "isis.rodriguezarana@dxc.com",
    "Monroe Township, NJ": "isis.rodriguezarana@dxc.com",
    "Staten Island, NY": "isis.rodriguezarana@dxc.com",
    "Hackensack, NJ": "isis.rodriguezarana@dxc.com",
    "Hawaii": "isis.rodriguezarana@dxc.com",
    "Kihei, HI": "isis.rodriguezarana@dxc.com",
    "San Diego, CA": "isis.rodriguezarana@dxc.com",
    "Noida": "pragnya.nagaraj@dxc.com",
    "Pune": "pragnya.nagaraj@dxc.com",
    "Munich Garching": "michael.knowlton@dxc.com",
    "Unterschleissheim": "michael.knowlton@dxc.com",
    "Kansas": "isis.rodriguezarana@dxc.com",
    "Overland Park, KS": "isis.rodriguezarana@dxc.com",
    "Rotterdam": "iliyana.geosheva@dxc.com",
    "South Hadley, MA": "isis.rodriguezarana@dxc.com",
    "Bloomfield Hills, MI": "isis.rodriguezarana@dxc.com",
    "Honolulu, HI": "isis.rodriguezarana@dxc.com",
    "Lindau": "michael.knowlton@dxc.com",
    "Gutmadingen": "michael.knowlton@dxc.com",
    "Krefeld": "michael.knowlton@dxc.com",
    "Koblenz": "michael.knowlton@dxc.com",
    "North Carolina": "isis.rodriguezarana@dxc.com",
    "Eschborn": "michael.knowlton@dxc.com",
    "Iselin, NJ": "isis.rodriguezarana@dxc.com",
    "Duncansville, PA": "isis.rodriguezarana@dxc.com",
    "Maryland": "isis.rodriguezarana@dxc.com",
    "White Marsh, MD": "isis.rodriguezarana@dxc.com",
    "GILBERT, AZ": "isis.rodriguezarana@dxc.com",
    "ANTIOCH, CA": "isis.rodriguezarana@dxc.com",
    "SAN RAMON, CA": "isis.rodriguezarana@dxc.com",
    "WESTON, FL": "isis.rodriguezarana@dxc.com",
    "MANSFIELD, MA": "isis.rodriguezarana@dxc.com",
    "CANTON, MI": "isis.rodriguezarana@dxc.com",
    "ROCHESTER, MI": "isis.rodriguezarana@dxc.com",
    "MADISON, MS": "isis.rodriguezarana@dxc.com",
    "Texas, Austin": "isis.rodriguezarana@dxc.com",
    "CEDAR PARK, TX": "isis.rodriguezarana@dxc.com",
    "LEANDER, TX": "isis.rodriguezarana@dxc.com",
    "PRINCETON, TX": "isis.rodriguezarana@dxc.com",
    "ROUND ROCK, TX": "isis.rodriguezarana@dxc.com",
    "MILL CREEK, WA": "isis.rodriguezarana@dxc.com",
    "SAMMAMISH, WA": "isis.rodriguezarana@dxc.com",
    "Orlando, FL": "isis.rodriguezarana@dxc.com",
    "Loudon, TN": "isis.rodriguezarana@dxc.com",
    "Other Russia Locations": "#N/A",
    "Utah": "isis.rodriguezarana@dxc.com",
    "Salt Lake City, UT": "isis.rodriguezarana@dxc.com",
    "Alamo, CA": "isis.rodriguezarana@dxc.com",
    "Marietta, GA": "isis.rodriguezarana@dxc.com",
    "Cedar Rapids, IA": "isis.rodriguezarana@dxc.com",
    "Ireland": "iliyana.geosheva@dxc.com",
    "Kuwait": "thi.t.nguyen@dxc.com",
    "El Salvador": "isis.rodriguezarana@dxc.com",
    "Other Ukraine Locations": "a.cherepovska@dxc.com",
    "Boca Raton, FL": "isis.rodriguezarana@dxc.com",
    "Georgia": "iliyana.geosheva@dxc.com",
    "Port Orchard, WA": "isis.rodriguezarana@dxc.com",
    "Robbinsville, NJ": "isis.rodriguezarana@dxc.com",
    "Argentina": "isis.rodriguezarana@dxc.com",
    "Austria": "iliyana.geosheva@dxc.com",
    "Slovakia": "iliyana.geosheva@dxc.com",
    "Belgium": "iliyana.geosheva@dxc.com",
    "Spain": "maria.quiroga@dxc.com",
    "Portugal": "maria.quiroga@dxc.com",
    "Finland": "iliyana.geosheva@dxc.com",
    "Norway": "iliyana.geosheva@dxc.com",
    "Brazil": "isis.rodriguezarana@dxc.com",
    "New Zealand": "thi.t.nguyen@dxc.com",
    "Buenos Aires": "isis.rodriguezarana@dxc.com",
    "Cordoba": "isis.rodriguezarana@dxc.com",
    "Adelaide": "thi.t.nguyen@dxc.com",
    "Other Australia Locations": "thi.t.nguyen@dxc.com",
    "Brindabella Business Park": "thi.t.nguyen@dxc.com",
    "Brisbane": "thi.t.nguyen@dxc.com",
    "Canberra": "thi.t.nguyen@dxc.com",
    "Macquarie Park": "thi.t.nguyen@dxc.com",
    "Mawson Lakes": "thi.t.nguyen@dxc.com",
    "Perth": "thi.t.nguyen@dxc.com",
    "Wollongong": "thi.t.nguyen@dxc.com",
    "Other Austria Locations": "iliyana.geosheva@dxc.com",
    "Linz": "iliyana.geosheva@dxc.com",
    "Vienna": "iliyana.geosheva@dxc.com",
    "Other Belgium Locations": "iliyana.geosheva@dxc.com",
    "Mechelen": "iliyana.geosheva@dxc.com",
    "Other Brazil Locations": "isis.rodriguezarana@dxc.com",
    "Araraquara": "isis.rodriguezarana@dxc.com",
    "Barueri": "isis.rodriguezarana@dxc.com",
    "Campinas": "isis.rodriguezarana@dxc.com",
    "Porto Alegre": "isis.rodriguezarana@dxc.com",
    "Rio De Janeiro": "isis.rodriguezarana@dxc.com",
    "Sao Paulo": "isis.rodriguezarana@dxc.com",
    "SaoBernardo doCampo": "isis.rodriguezarana@dxc.com",
    "ChongQing": "thi.t.nguyen@dxc.com",
    "Guangzhou": "thi.t.nguyen@dxc.com",
    "WuHan": "thi.t.nguyen@dxc.com",
    "Czech Republic": "iliyana.geosheva@dxc.com",
    "Hungary": "iliyana.geosheva@dxc.com",
    "Prague": "iliyana.geosheva@dxc.com",
    "Valby": "iliyana.geosheva@dxc.com",
    "Other Finland Locations": "iliyana.geosheva@dxc.com",
    "Dahlewitz": "michael.knowlton@dxc.com",
    "Dornach-Aschheim": "michael.knowlton@dxc.com",
    "Hamburg": "michael.knowlton@dxc.com",
    "Hannover": "michael.knowlton@dxc.com",
    "Heidelberg": "michael.knowlton@dxc.com",
    "Koeln": "michael.knowlton@dxc.com",
    "Oberursel": "michael.knowlton@dxc.com",
    "Ratingen": "michael.knowlton@dxc.com",
    "Ulm": "michael.knowlton@dxc.com",
    "Wolfsburg": "michael.knowlton@dxc.com",
    "Budapest": "iliyana.geosheva@dxc.com",
    "Indore": "pragnya.nagaraj@dxc.com",
    "Kolkata": "pragnya.nagaraj@dxc.com",
    "Other Japan Locations": "thi.t.nguyen@dxc.com",
    "Osaka": "thi.t.nguyen@dxc.com",
    "Cyberjaya": "atikah.aziz@dxc.com",
    "Auckland": "thi.t.nguyen@dxc.com",
    "Wellington": "thi.t.nguyen@dxc.com",
    "Oslo": "iliyana.geosheva@dxc.com",
    "Other Poland Locations": "nikola.falek@dxc.com",
    "Elblag": "nikola.falek@dxc.com",
    "Paco de Arcos": "maria.quiroga@dxc.com",
    "Other Romania Locations": "cristina.cotutiu@dxc.com",
    "Other Slovakia Locations": "iliyana.geosheva@dxc.com",
    "Avilés": "maria.quiroga@dxc.com",
    "Las Rozas": "maria.quiroga@dxc.com",
    "Madrid": "maria.quiroga@dxc.com",
    "Sant Cugat del Valles": "maria.quiroga@dxc.com",
    "Santiago de Compostela": "maria.quiroga@dxc.com",
    "Valencia": "maria.quiroga@dxc.com",
    "Zaragoza": "maria.quiroga@dxc.com",
    "Geneva": "iliyana.geosheva@dxc.com",
    "Liebefeld": "iliyana.geosheva@dxc.com",
    "Mendrisio": "iliyana.geosheva@dxc.com",
    "Meyrin": "iliyana.geosheva@dxc.com",
    "Wallisellen": "iliyana.geosheva@dxc.com",
    "Other Thailand Locations": "thi.t.nguyen@dxc.com",
    "Aldershot": "iliyana.geosheva@dxc.com",
    "Alfreton": "iliyana.geosheva@dxc.com",
    "Basildon": "iliyana.geosheva@dxc.com",
    "Bracknell": "iliyana.geosheva@dxc.com",
    "Chesterfield": "iliyana.geosheva@dxc.com",
    "Chorley": "iliyana.geosheva@dxc.com",
    "Derby": "iliyana.geosheva@dxc.com",
    "Erskine": "iliyana.geosheva@dxc.com",
    "Milton Keynes": "iliyana.geosheva@dxc.com",
    "Newcastle upon Tyne": "iliyana.geosheva@dxc.com",
    "Warrington": "iliyana.geosheva@dxc.com",
    "Serbia": "cupic.tamara@dxc.com",
    "Nicosia": "iliyana.geosheva@dxc.com",
    "Dublin": "iliyana.geosheva@dxc.com",
    "Sri Lanka": "thi.t.nguyen@dxc.com",
    "Colombo": "thi.t.nguyen@dxc.com",
    "Quezon": "thi.t.nguyen@dxc.com",
    "Taguig": "thi.t.nguyen@dxc.com",
    "Alaska": "isis.rodriguezarana@dxc.com",
    "Arkansas": "isis.rodriguezarana@dxc.com",
    "District of Columbia": "isis.rodriguezarana@dxc.com",
    "Indiana": "isis.rodriguezarana@dxc.com",
    "Nebraska": "isis.rodriguezarana@dxc.com",
    "New Mexico": "isis.rodriguezarana@dxc.com",
    "Oklahoma": "isis.rodriguezarana@dxc.com",
    "Oregon": "isis.rodriguezarana@dxc.com",
    "Puerto Rico": "isis.rodriguezarana@dxc.com",
    "Rhode Island": "isis.rodriguezarana@dxc.com",
    "South Carolina": "isis.rodriguezarana@dxc.com",
    "Maine": "isis.rodriguezarana@dxc.com",
    "Louisiana": "isis.rodriguezarana@dxc.com",
    "Kentucky": "isis.rodriguezarana@dxc.com",
    "Brussels": "iliyana.geosheva@dxc.com",
    "Conway, AR": "isis.rodriguezarana@dxc.com",
    "Cerritos, CA": "isis.rodriguezarana@dxc.com",
    "Fremont, CA": "isis.rodriguezarana@dxc.com",
    "San Mateo, CA": "isis.rodriguezarana@dxc.com",
    "Sunnyvale, CA": "isis.rodriguezarana@dxc.com",
    "Greenwood Village, CO": "isis.rodriguezarana@dxc.com",
    "East Hartford, CT": "isis.rodriguezarana@dxc.com",
    "Omaha, NE": "isis.rodriguezarana@dxc.com",
    "Jupiter, FL": "isis.rodriguezarana@dxc.com",
    "Oakbrook Terrace, IL": "isis.rodriguezarana@dxc.com",
    "Burns Harbor, IN": "isis.rodriguezarana@dxc.com",
    "Pennington, NJ": "isis.rodriguezarana@dxc.com",
    "Indianapolis, IN": "isis.rodriguezarana@dxc.com",
    "Warren, NJ": "isis.rodriguezarana@dxc.com",
    "New Orleans, LA": "isis.rodriguezarana@dxc.com",
    "Winston-Salem, NC": "isis.rodriguezarana@dxc.com",
    "Quincy, MA": "isis.rodriguezarana@dxc.com",
    "Waltham, MA": "isis.rodriguezarana@dxc.com",
    "Blue Ash, OH": "isis.rodriguezarana@dxc.com",
    "Auburn Hills, MI": "isis.rodriguezarana@dxc.com",
    "West Chester, OH": "isis.rodriguezarana@dxc.com",
    "Tulsa, OK": "isis.rodriguezarana@dxc.com",
    "Saginaw, MI": "isis.rodriguezarana@dxc.com",
    "Troy, MI": "isis.rodriguezarana@dxc.com",
    "Portland, OR": "isis.rodriguezarana@dxc.com",
    "Bellerive, MO": "isis.rodriguezarana@dxc.com",
    "Saint Louis, MO": "isis.rodriguezarana@dxc.com",
    "Bethlehem, PA": "isis.rodriguezarana@dxc.com",
    "Camp Hill, PA": "isis.rodriguezarana@dxc.com",
    "Coatesville, PA": "isis.rodriguezarana@dxc.com",
    "Isabela, PR": "isis.rodriguezarana@dxc.com",
    "El Paso, TX": "isis.rodriguezarana@dxc.com",
    "Richardson, TX": "isis.rodriguezarana@dxc.com",
    "Blythewood, SC": "isis.rodriguezarana@dxc.com",
    "Greenville, SC": "isis.rodriguezarana@dxc.com",
    "Tysons, VA": "isis.rodriguezarana@dxc.com",
    "Franklin, TN": "isis.rodriguezarana@dxc.com",
    "Pinhais": "isis.rodriguezarana@dxc.com",
    "Recife": "isis.rodriguezarana@dxc.com",
    "Ankara": "iliyana.geosheva@dxc.com",
    "Seville": "maria.quiroga@dxc.com",
    "Ontario, Toronto": "isis.rodriguezarana@dxc.com",
    "British Columbia, Vancouver": "isis.rodriguezarana@dxc.com",
    "Quebec, Montreal": "isis.rodriguezarana@dxc.com",
    "New Brunswick, Saint John": "isis.rodriguezarana@dxc.com",
    "Alberta, Calgary": "isis.rodriguezarana@dxc.com",
    "Ontario, Mississauga": "isis.rodriguezarana@dxc.com",
    "Ontario, Ottawa": "isis.rodriguezarana@dxc.com",
    "Costa Rica": "isis.rodriguezarana@dxc.com",
    "Alajuela": "isis.rodriguezarana@dxc.com",
    "Latvia": "iliyana.geosheva@dxc.com",
    "Riga": "iliyana.geosheva@dxc.com",
    "Guadalajara": "isis.rodriguezarana@dxc.com",
    "Mexico City": "isis.rodriguezarana@dxc.com",
    "Tlaquepaque": "isis.rodriguezarana@dxc.com",
    "Cernusco sul Naviglio": "iliyana.geosheva@dxc.com",
    "Bitritto": "iliyana.geosheva@dxc.com",
    "Pomezia": "iliyana.geosheva@dxc.com",
    "Idaho": "isis.rodriguezarana@dxc.com",
    "Princeton, NJ": "isis.rodriguezarana@dxc.com",
    "Santa Clara, CA": "isis.rodriguezarana@dxc.com",
    "Sofia": "m.tsvetkovalazarova@dxc.com",
    "Varna": "m.tsvetkovalazarova@dxc.com",
    "Belo Horizonte": "isis.rodriguezarana@dxc.com",
    "Gothenburg": "iliyana.geosheva@dxc.com",
    "Linkoping": "iliyana.geosheva@dxc.com",
    "Stockholm": "iliyana.geosheva@dxc.com",
    "Stockholm-Solna": "iliyana.geosheva@dxc.com",
    "Trollhattan": "iliyana.geosheva@dxc.com",
    "Other Sweden Locations": "iliyana.geosheva@dxc.com",
    "Slovenia": "iliyana.geosheva@dxc.com",
    "Kamnik": "iliyana.geosheva@dxc.com",
    "Paris": "iliyana.geosheva@dxc.com",
    "Nanterre": "iliyana.geosheva@dxc.com",
    "Paris La Defense Cedex": "iliyana.geosheva@dxc.com",
    "Abu Dhabi": "thi.t.nguyen@dxc.com",
    "Dubai": "thi.t.nguyen@dxc.com",
    "Ho Chi Minh": "thi.t.nguyen@dxc.com",
    "Antwerp": "iliyana.geosheva@dxc.com",
    "Galway": "iliyana.geosheva@dxc.com",
    "Rijswijk": "iliyana.geosheva@dxc.com",
    "Other Netherlands locations": "iliyana.geosheva@dxc.com",
    "Duebendorf": "iliyana.geosheva@dxc.com",
    "Nottinghamshire": "iliyana.geosheva@dxc.com",
    "Hong Kong City": "thi.t.nguyen@dxc.com",
    "Singapore City": "yvonne.chuahuifang@dxc.com",
    "Other New Zealand locations": "thi.t.nguyen@dxc.com",
    "Nova Scotia, Halifax": "isis.rodriguezarana@dxc.com",
    "Delaware": "isis.rodriguezarana@dxc.com",
    "Dalian": "thi.t.nguyen@dxc.com",
    "Aberdeen, MD": "isis.rodriguezarana@dxc.com",
    "Chatham": "iliyana.geosheva@dxc.com",
    "Birmingham": "iliyana.geosheva@dxc.com",
    "Belgrade": "cupic.tamara@dxc.com",
    "Leixlip": "iliyana.geosheva@dxc.com",
    "Other Ireland Locations": "iliyana.geosheva@dxc.com",
    "Ontario, Provincewide": "isis.rodriguezarana@dxc.com",
    "Alabama": "isis.rodriguezarana@dxc.com",
    "Jasper, AL": "isis.rodriguezarana@dxc.com",
    "Chandler, AZ": "isis.rodriguezarana@dxc.com",
    "Arizona, Phoenix": "isis.rodriguezarana@dxc.com",
    "Alameda, CA": "isis.rodriguezarana@dxc.com",
    "Berkeley, CA": "isis.rodriguezarana@dxc.com",
    "Benicia, CA": "isis.rodriguezarana@dxc.com",
    "Tollhouse, CA": "isis.rodriguezarana@dxc.com",
    "Dublin, CA": "isis.rodriguezarana@dxc.com",
    "Fort Lupton, CO": "isis.rodriguezarana@dxc.com",
    "Lakewood Ranch, FL": "isis.rodriguezarana@dxc.com",
    "Daytona Beach Shores, FL": "isis.rodriguezarana@dxc.com",
    "Middleburg, FL": "isis.rodriguezarana@dxc.com",
    "Indialantic, FL": "isis.rodriguezarana@dxc.com",
    "Rockford, IL": "isis.rodriguezarana@dxc.com",
    "Lisle, IL": "isis.rodriguezarana@dxc.com",
    "Schaumburg, IL": "isis.rodriguezarana@dxc.com",
    "Chevy Chase, MD": "isis.rodriguezarana@dxc.com",
    "Walpole, MA": "isis.rodriguezarana@dxc.com",
    "Chanhassen, MN": "isis.rodriguezarana@dxc.com",
    "Prior Lake, MN": "isis.rodriguezarana@dxc.com",
    "Durham, NC": "isis.rodriguezarana@dxc.com",
    "Kingston, TN": "isis.rodriguezarana@dxc.com",
    "Chandler, TX": "isis.rodriguezarana@dxc.com",
    "Waxahachie, TX": "isis.rodriguezarana@dxc.com",
    "Burleson, TX": "isis.rodriguezarana@dxc.com",
    "Mckinney, TX": "isis.rodriguezarana@dxc.com",
    "Mesquite, TX": "isis.rodriguezarana@dxc.com",
    "Reno, TX": "isis.rodriguezarana@dxc.com",
    "Argyle, TX": "isis.rodriguezarana@dxc.com",
    "Arlington, TX": "isis.rodriguezarana@dxc.com",
    "Anna, TX": "isis.rodriguezarana@dxc.com",
    "Sugar Land, TX": "isis.rodriguezarana@dxc.com",
    "Bedford, TX": "isis.rodriguezarana@dxc.com",
    "Colleyville, TX": "isis.rodriguezarana@dxc.com",
    "Sulphur Springs, TX": "isis.rodriguezarana@dxc.com",
    "Flowermound, TX": "isis.rodriguezarana@dxc.com",
    "Grapevine, TX": "isis.rodriguezarana@dxc.com",
    "Charlottesville, VA": "isis.rodriguezarana@dxc.com",
    "Leesburg, VA": "isis.rodriguezarana@dxc.com",
    "Alexandria, VA": "isis.rodriguezarana@dxc.com",
    "Springfield, VA": "isis.rodriguezarana@dxc.com",
    "Tunisia": "thi.t.nguyen@dxc.com",
    "Tunis": "thi.t.nguyen@dxc.com",
    "Other France Locations": "iliyana.geosheva@dxc.com",
    "Parker, CO": "isis.rodriguezarana@dxc.com",
    "Fort Lauderdale, FL": "isis.rodriguezarana@dxc.com",
    "Wisconsin": "isis.rodriguezarana@dxc.com",
    "Madison, WI": "isis.rodriguezarana@dxc.com",
    "Cape Town": "thi.t.nguyen@dxc.com",
    "Las Pinas": "thi.t.nguyen@dxc.com",
    "Suzhou": "thi.t.nguyen@dxc.com",
    "New Delhi": "pragnya.nagaraj@dxc.com",
    "Mauritius": "thi.t.nguyen@dxc.com",
    "Moka": "thi.t.nguyen@dxc.com",
    "Nagpur": "pragnya.nagaraj@dxc.com",
    "Wuxi": "thi.t.nguyen@dxc.com",
    "Ningbo": "thi.t.nguyen@dxc.com",
    "Chengdu": "thi.t.nguyen@dxc.com",
    "Mason, OH": "isis.rodriguezarana@dxc.com",
    "Irmo, SC": "isis.rodriguezarana@dxc.com",
    "Flanders, NJ": "isis.rodriguezarana@dxc.com",
    "Greencastle, PA": "isis.rodriguezarana@dxc.com",
    "Clemmons, NC": "isis.rodriguezarana@dxc.com",
    "Littleton, CO": "isis.rodriguezarana@dxc.com",
    "Puyallup, WA": "isis.rodriguezarana@dxc.com",
    "Newport, RI": "isis.rodriguezarana@dxc.com",
    "Israel": "thi.t.nguyen@dxc.com",
    "Petah-Tikva": "thi.t.nguyen@dxc.com",
    "Egypt": "cupic.tamara@dxc.com",
    "Cairo": "cupic.tamara@dxc.com",
    "Zimbabwe": "thi.t.nguyen@dxc.com",
    "Harare": "thi.t.nguyen@dxc.com",
    "Pakistan": "thi.t.nguyen@dxc.com",
    "Rawalpindi": "thi.t.nguyen@dxc.com",
    "Johannesburg": "thi.t.nguyen@dxc.com",
    "Nelson": "thi.t.nguyen@dxc.com",
    "Zurich": "iliyana.geosheva@dxc.com",
    "Claymont, DE": "isis.rodriguezarana@dxc.com",
    "Santa Cruz de Tenerife": "maria.quiroga@dxc.com",
    "Greece": "iliyana.geosheva@dxc.com",
    "Athens": "iliyana.geosheva@dxc.com",
    "Nanjing": "thi.t.nguyen@dxc.com",
    "San Jose": "isis.rodriguezarana@dxc.com",
    "Manitoba, Winnipeg": "isis.rodriguezarana@dxc.com",
    "Lisbon": "maria.quiroga@dxc.com",
    "Barcelona": "maria.quiroga@dxc.com",
    "Other Italy Locations": "iliyana.geosheva@dxc.com",
    "Milan": "iliyana.geosheva@dxc.com",
    "Bahrain": "thi.t.nguyen@dxc.com",
    "Manama": "thi.t.nguyen@dxc.com",
    "West Virginia": "isis.rodriguezarana@dxc.com",
    "Lebanon": "thi.t.nguyen@dxc.com",
    "Beirut": "thi.t.nguyen@dxc.com",
    "Paraguay": "isis.rodriguezarana@dxc.com",
    "Encarnacion": "isis.rodriguezarana@dxc.com",
    "Tbilisi": "iliyana.geosheva@dxc.com",
    "Santa Fe, NM": "isis.rodriguezarana@dxc.com",
    "Other Serbia Locations": "cupic.tamara@dxc.com",
    "Frankfort, KY": "isis.rodriguezarana@dxc.com",
    "Tel Aviv": "thi.t.nguyen@dxc.com",
    "Qatar": "thi.t.nguyen@dxc.com",
    "Doha": "thi.t.nguyen@dxc.com",
    "Colombia": "isis.rodriguezarana@dxc.com",
    "Medellin": "isis.rodriguezarana@dxc.com",
    "Azerbaijan": "iliyana.geosheva@dxc.com",
    "Baku": "iliyana.geosheva@dxc.com",
    "Greve": "iliyana.geosheva@dxc.com",
    "Melby": "iliyana.geosheva@dxc.com",
    "Armenia": "iliyana.geosheva@dxc.com",
    "Yerevan": "iliyana.geosheva@dxc.com",
    "Espoo": "iliyana.geosheva@dxc.com",
    "Bangladesh": "thi.t.nguyen@dxc.com",
    "Dhaka": "thi.t.nguyen@dxc.com",
    "Karachi": "thi.t.nguyen@dxc.com",
    "Kazakhstan": "thi.t.nguyen@dxc.com",
    "Astana": "thi.t.nguyen@dxc.com",
    "Montana": "isis.rodriguezarana@dxc.com",
    "Missoula, MT": "isis.rodriguezarana@dxc.com",
    "Alaska, Statewide": "isis.rodriguezarana@dxc.com",
    "Nigeria": "thi.t.nguyen@dxc.com",
    "Lagos": "thi.t.nguyen@dxc.com",
    "Lutz, FL": "isis.rodriguezarana@dxc.com",
    "Vermont": "isis.rodriguezarana@dxc.com",
    "Wilmington, VT": "isis.rodriguezarana@dxc.com",
    "Moldova": "iliyana.geosheva@dxc.com",
    "Kishinev": "iliyana.geosheva@dxc.com",
    "Kyrgyzstan": "thi.t.nguyen@dxc.com",
    "Bishkek": "thi.t.nguyen@dxc.com",
    "Ontario": "isis.rodriguezarana@dxc.com",
    "Quebec": "isis.rodriguezarana@dxc.com",
    "British Columbia": "isis.rodriguezarana@dxc.com",
    "Manitoba": "isis.rodriguezarana@dxc.com",
    "New Brunswick": "isis.rodriguezarana@dxc.com",
    "Alberta": "isis.rodriguezarana@dxc.com",
    "Nova Scotia": "isis.rodriguezarana@dxc.com",
    "Newfoundland and Labrador": "isis.rodriguezarana@dxc.com",
    "Prince Edward Island": "isis.rodriguezarana@dxc.com",
    "Saskatchewan": "isis.rodriguezarana@dxc.com",
    "Yukon": "isis.rodriguezarana@dxc.com",
    "Nunavut": "isis.rodriguezarana@dxc.com",
    "Northwest Territories": "isis.rodriguezarana@dxc.com",
    "Quebec, Provincewide": "isis.rodriguezarana@dxc.com",
    "British Columbia, Provincewide": "isis.rodriguezarana@dxc.com",
    "Manitoba, Provincewide": "isis.rodriguezarana@dxc.com",
    "New Brunswick, Provincewide": "isis.rodriguezarana@dxc.com",
    "Alberta, Provincewide": "isis.rodriguezarana@dxc.com",
    "Nova Scotia, Provincewide": "isis.rodriguezarana@dxc.com",
    "NL, Provincewide": "isis.rodriguezarana@dxc.com",
    "PEI, Provincewide": "isis.rodriguezarana@dxc.com",
    "Saskatchewan, Provincewide": "isis.rodriguezarana@dxc.com",
    "Yukon, Territorywide": "isis.rodriguezarana@dxc.com",
    "Nunavut, Territorywide": "isis.rodriguezarana@dxc.com",
    "NWT, Territorywide": "isis.rodriguezarana@dxc.com",
    "North Dakota": "isis.rodriguezarana@dxc.com",
    "South Dakota": "isis.rodriguezarana@dxc.com",
    "Wyoming": "isis.rodriguezarana@dxc.com",
    "Alabama, Statewide": "isis.rodriguezarana@dxc.com",
    "Arizona, Statewide": "isis.rodriguezarana@dxc.com",
    "Arkansas, Statewide": "isis.rodriguezarana@dxc.com",
    "California, Statewide": "isis.rodriguezarana@dxc.com",
    "Colorado, Statewide": "isis.rodriguezarana@dxc.com",
    "Connecticut, Statewide": "isis.rodriguezarana@dxc.com",
    "Delaware, Statewide": "isis.rodriguezarana@dxc.com",
    "Florida, Statewide": "isis.rodriguezarana@dxc.com",
    "Georgia, Statewide": "isis.rodriguezarana@dxc.com",
    "Hawaii, Statewide": "isis.rodriguezarana@dxc.com",
    "Idaho, Statewide": "isis.rodriguezarana@dxc.com",
    "Illinois, Statewide": "isis.rodriguezarana@dxc.com",
    "Indiana, Statewide": "isis.rodriguezarana@dxc.com",
    "Iowa, Statewide": "isis.rodriguezarana@dxc.com",
    "Kansas, Statewide": "isis.rodriguezarana@dxc.com",
    "Kentucky, Statewide": "isis.rodriguezarana@dxc.com",
    "Louisiana, Statewide": "isis.rodriguezarana@dxc.com",
    "Maine, Statewide": "isis.rodriguezarana@dxc.com",
    "Maryland, Statewide": "isis.rodriguezarana@dxc.com",
    "Massachusetts, Statewide": "isis.rodriguezarana@dxc.com",
    "Michigan, Statewide": "isis.rodriguezarana@dxc.com",
    "Minnesota, Statewide": "isis.rodriguezarana@dxc.com",
    "Mississippi, Statewide": "isis.rodriguezarana@dxc.com",
    "Missouri, Statewide": "isis.rodriguezarana@dxc.com",
    "Montana, Statewide": "isis.rodriguezarana@dxc.com",
    "Nebraska, Statewide": "isis.rodriguezarana@dxc.com",
    "Nevada, Statewide": "isis.rodriguezarana@dxc.com",
    "New Hampshire, Statewide": "isis.rodriguezarana@dxc.com",
    "New Jersey, Statewide": "isis.rodriguezarana@dxc.com",
    "New Mexico, Statewide": "isis.rodriguezarana@dxc.com",
    "New York, Statewide": "isis.rodriguezarana@dxc.com",
    "North Carolina, Statewide": "isis.rodriguezarana@dxc.com",
    "North Dakota, Statewide": "isis.rodriguezarana@dxc.com",
    "Ohio, Statewide": "isis.rodriguezarana@dxc.com",
    "Oklahoma, Statewide": "isis.rodriguezarana@dxc.com",
    "Oregon, Statewide": "isis.rodriguezarana@dxc.com",
    "Pennsylvania, Statewide": "isis.rodriguezarana@dxc.com",
    "Rhode Island, Statewide": "isis.rodriguezarana@dxc.com",
    "South Carolina, Statewide": "isis.rodriguezarana@dxc.com",
    "South Dakota, Statewide": "isis.rodriguezarana@dxc.com",
    "Tennessee, Statewide": "isis.rodriguezarana@dxc.com",
    "Texas, Statewide": "isis.rodriguezarana@dxc.com",
    "Utah, Statewide": "isis.rodriguezarana@dxc.com",
    "Vermont, Statewide": "isis.rodriguezarana@dxc.com",
    "Virginia, Statewide": "isis.rodriguezarana@dxc.com",
    "Washington, Statewide": "isis.rodriguezarana@dxc.com",
    "West Virginia, Statewide": "isis.rodriguezarana@dxc.com",
    "Wisconsin, Statewide": "isis.rodriguezarana@dxc.com",
    "Wyoming, Statewide": "isis.rodriguezarana@dxc.com",
    "Puerto Rico, Statewide": "isis.rodriguezarana@dxc.com",
    "Stamford, CT": "isis.rodriguezarana@dxc.com",
    "Parsippany, NJ": "isis.rodriguezarana@dxc.com",
    "Texas, Plano": "isis.rodriguezarana@dxc.com",
    "Broomfield, CO": "isis.rodriguezarana@dxc.com",
    "Texas, Houston": "isis.rodriguezarana@dxc.com",
    "Pittsburgh, PA": "isis.rodriguezarana@dxc.com",
    "Cupertino, CA": "isis.rodriguezarana@dxc.com",
    "Spokane, WA": "isis.rodriguezarana@dxc.com",
    "Georgia, Atlanta": "isis.rodriguezarana@dxc.com",
    "South Africa": "thi.t.nguyen@dxc.com",
    "San Francisco, CA": "isis.rodriguezarana@dxc.com",
    "New York": "isis.rodriguezarana@dxc.com",
    "Florida": "isis.rodriguezarana@dxc.com",
    "Berkeley Heights, NJ": "isis.rodriguezarana@dxc.com",
    "Charleston, WV": "isis.rodriguezarana@dxc.com",
    "Ukraine": "a.cherepovska@dxc.com",
    "Norfolk, MA": "isis.rodriguezarana@dxc.com",
    "Colorado": "isis.rodriguezarana@dxc.com",
    "New Jersey, East Hanover": "isis.rodriguezarana@dxc.com",
    "Montvale, NJ": "isis.rodriguezarana@dxc.com",
    "Massachusetts": "isis.rodriguezarana@dxc.com",
    "Redding, CT": "isis.rodriguezarana@dxc.com",
    "Washington, Redmond": "isis.rodriguezarana@dxc.com",
    "Highland Village, TX": "isis.rodriguezarana@dxc.com",
    "Washington, Kirkland": "isis.rodriguezarana@dxc.com",
    "Audubon, PA": "isis.rodriguezarana@dxc.com",
    "Pennsylvania": "isis.rodriguezarana@dxc.com",
    "Milpitas, CA": "isis.rodriguezarana@dxc.com",
    "New Jersey": "isis.rodriguezarana@dxc.com",
    "New Jersey, Middletown": "isis.rodriguezarana@dxc.com",
    "test": "test@test.com"
}